import { Typography } from '@mui/material';
import { ReactNode } from 'react';

type HeaderTextProps = {
  children: ReactNode;
};

export const HeaderText = (props: HeaderTextProps) => (
  <Typography variant="h4">{props.children}</Typography>
);
